import React, { useState } from 'react';
import { Row, Container, Card, CardBody, Form, Badge, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { ModalButtonBuilder, RegisteredInputsBuilder, ButtonBuilder, ApiRequest, ToastBuilder } from '../../../../../../../../GlobalComponents/Builders';
import { Trash2 } from 'react-feather';
import moment from 'moment';

const AssessmentHeader = ({
    assessment,
    statusColors,
    statusOptions,
    metaRegister,
    metaErrors,
    metaControl,
    metaSetValue,
    metaHandleSubmit,
    handleMetaUpdate,
    navigate,
    sectionDefs = [],
    sections = {},
    assessmentId,
    onSectionDeleted,
}) => {
    const [manageOpen, setManageOpen] = useState(false);
    const [deleting, setDeleting] = useState(null);
    const [confirmKey, setConfirmKey] = useState(null);

    const handleDeleteSection = (sectionKey) => {
        setDeleting(sectionKey);
        ApiRequest('DELETE', '/dmt/assessments/{assessmentId}/sections/{sectionKey}', {
            pathParams: { assessmentId, sectionKey },
            queryParams: { hardDelete: 'true' },
        }).then(res => {
            setDeleting(null);
            setConfirmKey(null);
            if (res.success) {
                ToastBuilder('success', `Section "${sectionKey}" deleted`);
                if (onSectionDeleted) onSectionDeleted(sectionKey);
            } else {
                ToastBuilder('error', res.error || 'Failed to delete section');
            }
        });
    };

    return (
        <Row>
            <Container>
                <Card>
                    <CardBody>
                        <div className='d-flex justify-content-between align-items-start'>
                            <div>
                                <h4>{assessment.name}</h4>
                                {assessment.description && <p className='text-muted mb-1'>{assessment.description}</p>}
                                <Badge color={statusColors[assessment.status] || 'secondary'} className='me-2'>
                                    {(assessment.status || 'draft').replace('_', ' ')}
                                </Badge>
                                <span className='text-muted' style={{ fontSize: 'small' }}>
                                    Created by {assessment.created_by_name || assessment.created_by || 'Unknown'} · {assessment.created_at ? moment.utc(assessment.created_at * 1000).fromNow() : ''}
                                </span>
                            </div>
                            <div className='d-flex gap-2'>
                                <ButtonBuilder form='' label='Back' className='btn-info btn-sm' onClick={() => navigate(`${process.env.PUBLIC_URL}/data-migration/assessments`)} />
                                <ModalButtonBuilder
                                    title='Edit Details'
                                    className='btn-outline-secondary btn-sm'
                                    formId='edit-assessment-meta-form'
                                    onClick={() => {
                                        metaSetValue('name', assessment.name);
                                        metaSetValue('description', assessment.description);
                                        metaSetValue('status', assessment.status);
                                    }}
                                    body={
                                        <Form id='edit-assessment-meta-form' onSubmit={metaHandleSubmit(handleMetaUpdate)}>
                                            <RegisteredInputsBuilder
                                                registrator={metaRegister}
                                                registratorErrors={metaErrors}
                                                control={metaControl}
                                                inputs={[
                                                    { label: 'Name', name: 'name', required: true, labelSize: 3 },
                                                    { label: 'Description', name: 'description', type: 'textarea', labelSize: 3, settings: { resize: true }, style: { height: 80 } },
                                                    { label: 'Status', name: 'status', type: 'reactselect', labelSize: 3, options: statusOptions },
                                                ]}
                                            />
                                        </Form>
                                    }
                                />
                                <button className='btn btn-sm btn-outline-danger' onClick={() => setManageOpen(true)}>
                                    Manage Sections
                                </button>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                {/* Manage Sections Modal */}
                <Modal isOpen={manageOpen} toggle={() => setManageOpen(false)} size='md'>
                    <ModalHeader toggle={() => setManageOpen(false)}>Manage Sections</ModalHeader>
                    <ModalBody>
                        <p className='text-muted mb-3' style={{ fontSize: 13 }}>
                            Delete a section to reset its data. This permanently removes saved data for that section.
                        </p>
                        {sectionDefs.map(({ key, title }) => {
                            const hasSavedData = !!sections[key];
                            return (
                                <div key={key} className='d-flex justify-content-between align-items-center py-2' style={{ borderBottom: '1px solid rgba(128,128,128,0.1)' }}>
                                    <div>
                                        <strong style={{ fontSize: 13 }}>{title}</strong>
                                        {hasSavedData
                                            ? <Badge color='success' className='ms-2' style={{ fontSize: 10 }}>Has Data</Badge>
                                            : <Badge color='secondary' className='ms-2' style={{ fontSize: 10 }}>Empty</Badge>
                                        }
                                    </div>
                                    <div className='d-flex align-items-center gap-2'>
                                        {confirmKey === key ? (
                                            <>
                                                <span style={{ fontSize: 12, color: '#dc3545' }}>Delete?</span>
                                                <button className='btn btn-sm btn-danger' disabled={deleting === key} onClick={() => handleDeleteSection(key)}>
                                                    {deleting === key ? '...' : 'Yes'}
                                                </button>
                                                <button className='btn btn-sm btn-outline-secondary' onClick={() => setConfirmKey(null)}>No</button>
                                            </>
                                        ) : (
                                            <button
                                                className='btn btn-sm btn-outline-danger'
                                                disabled={!hasSavedData}
                                                onClick={() => setConfirmKey(key)}
                                            >
                                                <Trash2 size={14} />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </ModalBody>
                </Modal>
            </Container>
        </Row>
    );
};

export default AssessmentHeader;
